export type FlowType = 'secretary' | 'proprietor' | 'partnership';
export type ObjectNumber = { [key: string]: number };
